import { useGetUser, useUserSettingsUpdate } from 'src/hooks';
import { ImageStyleSelect } from 'src/components/ImageGenSettings/components/ImageStyleSelect';
import { Dimensions } from 'src/components/ImageGenSettings/components/Dimensions';
import { UpsellMessage } from 'src/components/UpsellMessage';
import { TextDivider } from 'src/v2/commonComponents/TextDivider';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './ImageSettings.module.scss';
import {
  ImageGenNewSettingsDimensionOptionTypes,
  SettingKeys,
} from 'src/types/settings';
import { ImageGenStyles } from 'src/types';
import log from 'src/utils/logger';
import { SAVED_TEXT } from 'src/constants';
import { toast } from 'react-toastify';

export const ImageSettings = () => {
  const { isFreeTier, isOpenTier, isStandardTier } = useGetUser();
  const { updateUserSetting } = useUserSettingsUpdate();

  const handleResetClick = () => {
    try {
      updateUserSetting({
        value: ImageGenNewSettingsDimensionOptionTypes.SQUARE,
        hideToast: true,
        settingKey: SettingKeys.IMAGE_DIMENTIONS,
      });
      updateUserSetting({
        value: ImageGenStyles.NONE,
        hideToast: true,
        settingKey: SettingKeys.IMAGE_STYLES,
      });
    } catch (e) {
      log.error(e);
    } finally {
      toast.success(SAVED_TEXT);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        {(isOpenTier || isFreeTier || isStandardTier) && (
          <UpsellMessage
            title="Customize your images"
            description="Unlock high-resolution images with 11 aspect ratios and the ability to select from multiple image styles"
            dataGTMNinjaTier="Customize-images-upgrade"
            dataGTMOpenTier="Customize-images-signup"
            buttonStyle="with-background"
            buttonLabel="Upgrade to unlock"
            className={styles.upsellMessage}
          />
        )}

        <Dimensions />

        <TextDivider />

        <ImageStyleSelect />
      </div>

      <div className={styles.resetButtonWrapper}>
        <Button
          className={styles.resetButton}
          type="button"
          onClick={handleResetClick}
          color="link"
        >
          Reset
        </Button>
      </div>
    </div>
  );
};
